import React from "react";
import ImageGallery from "react-image-gallery";

function ImageViewer({ gallery }) {
  const images = gallery.map(({ id, description, image, trending }) => ({
    original: image ? image : "",
    thumbnail: image ? image : "",
    description: description,
    lazyLoad: true,
  }));

  return <ImageGallery lazyLoad items={images} />;
}

export default ImageViewer;
